import React, { useEffect, useState } from "react";
import { Form, Button, Spinner, Alert, InputGroup } from "react-bootstrap";
import * as configuracionApi from "../../api/configuracion";

const MINUTOS_MINIMO = 15;
const MINUTOS_MAXIMO = 3 * 24 * 60; // 3 días

const PRESETS = [
  { etiqueta: "15 min", minutos: 15 },
  { etiqueta: "30 min", minutos: 30 },
  { etiqueta: "1 hora", minutos: 60 },
  { etiqueta: "2 horas", minutos: 120 },
  { etiqueta: "6 horas", minutos: 360 },
  { etiqueta: "12 horas", minutos: 720 },
  { etiqueta: "24 horas", minutos: 1440 },
  { etiqueta: "2 días", minutos: 2880 },
  { etiqueta: "3 días", minutos: 4320 },
];

function formatoDuracion(minutos) {
  if (!minutos) return "";
  if (minutos < 60) return `${minutos} minuto${minutos === 1 ? "" : "s"}`;
  if (minutos % 1440 === 0) { const d = minutos / 1440; return `${d} día${d === 1 ? "" : "s"}`; }
  if (minutos % 60 === 0) { const h = minutos / 60; return `${h} hora${h === 1 ? "" : "s"}`; }
  return `${minutos} minutos`;
}

export default function Configuracion() {
  const [minutos, setMinutos] = useState(120);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const cargar = async () => {
    setCargando(true);
    try {
      const r = await configuracionApi.obtenerConfigResetPassword();
      setMinutos(r.minutosExpiracion);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMensaje("");
    setGuardando(true);
    try {
      await configuracionApi.actualizarConfigResetPassword(Number(minutos));
      setMensaje("Configuración actualizada correctamente.");
    } catch (err) {
      setError(err.response?.data?.mensaje || "No se pudo guardar la configuración.");
    } finally {
      setGuardando(false);
    }
  };

  if (cargando) return <Spinner animation="border" />;

  return (
    <div>
      <h4 className="mb-3">Mantenimiento &gt; Configuración</h4>

      <div className="fs-card" style={{ maxWidth: 520 }}>
        <h6 className="mb-1">Recuperar contraseña</h6>
        <p className="text-muted small">
          Tiempo que permanece válido el enlace de restablecimiento de contraseña que se envía por correo,
          desde que se solicita hasta que caduca. Una vez usado para cambiar la contraseña, deja de servir.
        </p>

        {error && <Alert variant="danger" className="py-2">{error}</Alert>}
        {mensaje && <Alert variant="success" className="py-2">{mensaje}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
            <Form.Label className="small mb-1">Tiempo de expiración (minutos)</Form.Label>
            <InputGroup style={{ maxWidth: 240 }}>
              <Form.Control
                type="number"
                min={MINUTOS_MINIMO}
                max={MINUTOS_MAXIMO}
                value={minutos}
                onChange={(e) => setMinutos(e.target.value)}
                required
              />
              <InputGroup.Text>min</InputGroup.Text>
            </InputGroup>
            <Form.Text className="text-muted">
              Entre {MINUTOS_MINIMO} minutos y {MINUTOS_MAXIMO / 1440} días. Equivale a {formatoDuracion(Number(minutos))}.
            </Form.Text>
          </Form.Group>

          <div className="d-flex flex-wrap gap-2 mb-3">
            {PRESETS.map((p) => (
              <Button
                key={p.minutos}
                size="sm"
                variant={Number(minutos) === p.minutos ? "primary" : "outline-secondary"}
                onClick={() => setMinutos(p.minutos)}
                type="button"
              >
                {p.etiqueta}
              </Button>
            ))}
          </div>

          <Button type="submit" variant="primary" disabled={guardando}>
            {guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}
          </Button>
        </Form>
      </div>
    </div>
  );
}
